module.exports = __webpack_public_path__ + "/ad56e504508a78303cf7dd8f0d6a04d0.png";